const TodoIntervalEnum = {
  SINGLE: 'single',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  YEARLY: 'yearly',
}

export default Object.freeze(TodoIntervalEnum)
